import { render } from "./ua-markdown.vue?vue&type=template&id=52e80a1f&scoped=true"
import script from "./ua-markdown.vue?vue&type=script&lang=js"
export * from "./ua-markdown.vue?vue&type=script&lang=js"

import "./ua-markdown.vue?vue&type=style&index=0&id=52e80a1f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e80a1f"]])

export default __exports__